<ul class="pagination pagination-primary" *ngIf="pages.length > 1">
  <li class="page-item" [class.disabled]="!isPreviousPageEnabled" (click)="goPreviousPage()">
    <a class="page-link">Previous</a>
  </li>

  <ng-container *ngFor="let page of pages; trackBy: trackByFn">
    <li class="page-item" [class.active]="pagination.page === page" (click)="goPage(page)">
      <a class="page-link">{{ page }}</a>
    </li>
  </ng-container>

  <li class="page-item" [class.disabled]="!isNextPageEnabled" (click)="goNextPage()">
    <a class="page-link">Next</a>
  </li>
</ul>
